import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { aiEntitlementResource } from '@jira/router-resources__ai-entitlement/src/aiEntitlementResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { aiSurveyCreateRoute } from '@jira/router-routes__servicedesk-surveys-routes/src/aiSurveyCreateRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { aiSurveyCreatePageEntryPoint } from './ui/ai-survey-create.tsx';

export const aiSurveyCreateRouteEntry: Route = createEntry(aiSurveyCreateRoute, () => ({
	group: 'aifc',
	ufoName: 'jsm.ai-create-survey',
	layout: chromelessLayout,
	resources: [aiEntitlementResource],
	entryPoint: () => (fg('surveys-aifc') ? aiSurveyCreatePageEntryPoint : notFoundPageEntrypoint),
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
